export default "__VITE_ASSET__Cktx_H_q__"